export const selectUser = (state: any): any => state.user;
